/* Footer retro simples */
import React from 'react';

interface FooterProps {
  t: (key: string, vars?: Record<string, string | number>) => string;
}

export function Footer({ t }: FooterProps) {
  return (
    <footer
      style={{
        borderTop: '1px solid var(--ink-soft)',
        padding: '14px 20px',
        textAlign: 'center',
        background: 'var(--ink)',
      }}
    >
      <div
        style={{
          fontFamily: 'var(--font-sans)',
          fontSize: '12px',
          color: 'var(--ink-mute)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '16px',
          flexWrap: 'wrap',
        }}
      >
        <span>{t('footer.copyright')}</span>
        <span aria-hidden="true" style={{ color: 'var(--ink-soft)' }}>·</span>
        <a
          href="https://drpera.com.br/privacidade"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: 'var(--ink-mute)', textDecoration: 'none' }}
        >
          {t('footer.privacy')}
        </a>
        <span aria-hidden="true" style={{ color: 'var(--ink-soft)' }}>·</span>
        <a
          href="https://drpera.com.br/termos"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: 'var(--ink-mute)', textDecoration: 'none' }}
        >
          {t('footer.terms')}
        </a>
        <span aria-hidden="true" style={{ color: 'var(--ink-soft)' }}>·</span>
        <a
          href="https://drpera.com.br"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: 'var(--ink-light)', textDecoration: 'none' }}
        >
          {t('footer.site')}
        </a>
      </div>
    </footer>
  );
}
